import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-redirect-black",
  "use": "icon-redirect-black-usage",
  "viewBox": "0 0 18.88 18.88",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.88 18.88\" id=\"icon-redirect-black\"><title>icon-redirect-black</title><path d=\"M17.88,9.83a1,1,0,0,0-1,1v6H2V2H8A1,1,0,0,0,8,0H1A1,1,0,0,0,0,1V17.88a1,1,0,0,0,1,1H17.88a1,1,0,0,0,1-1v-7a1,1,0,0,0-.95-1.05Z\" /><path d=\"M18.85.86a1,1,0,0,0,0-.24A1,1,0,0,0,18.3.08.88.88,0,0,0,17.91,0H13.43a1,1,0,0,0,0,2h2L9.3,8.17a1,1,0,0,0,1.41,1.41l6.17-6.17v2a1,1,0,0,0,2,0V1Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol